export interface PublishedRevision {
  selectionKey: string
  revision: number
}

/** Keep the loaded revision attached to the target whose request produced it. */
export function resolvePublishedRevision(
  metadata: { programYear: number; revision: number },
  programId: string,
  year: string,
): PublishedRevision {
  if (metadata.programYear !== Number(year) || !Number.isSafeInteger(metadata.revision) || metadata.revision < 0) {
    throw new Error("The selected program year has no valid published revision.")
  }
  return { selectionKey: `${programId}:${year}`, revision: metadata.revision }
}

/** A changed selection must be disabled immediately, even before its loading effect runs. */
export function revisionForSelection(loaded: PublishedRevision | null, selectionKey: string): number | null {
  return loaded?.selectionKey === selectionKey ? loaded.revision : null
}
